import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const WritingTask1Intro = () => {
  const { mockId } = useParams();
  const navigate = useNavigate();
  const [readingText, setReadingText] = useState(null);
  const [timeLeft, setTimeLeft] = useState(180); // 3 minutes = 180 seconds

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`/data/${mockId}Writing1.json`);
        const data = await res.json();
        setReadingText(data.passage);
      } catch (err) {
        console.error('Error loading writing passage:', err);
      }
    };
    fetchData();
  }, [mockId]);

  useEffect(() => {
    if (timeLeft <= 0) {
      navigate(`/lessonMock/${mockId}/writing/1/listening`);
      return;
    }
    const timer = setTimeout(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, navigate, mockId]);

  // Helper function to format seconds into MM:SS
  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-center">Writing Task 1 - Integrated Writing</h1>

      {/* ⏳ Timer */}
      <div className="text-center mb-6 text-gray-600">
      <span role="img" aria-label="hourglass">⏳</span>      Time Left: <span className="font-semibold">{formatTime(timeLeft)}</span>
        <p className="mt-6 text-gray-600 text-center">
        <b>You will automatically proceed to the Listening section after the timer ends.</b>
      </p>
      </div>

      {/* 📖 Reading Passage */}
      {!readingText ? (
        <p>Loading passage...</p>
      ) : (
        <div className="space-y-4">
          {Array.isArray(readingText)
            ? readingText.map((para, idx) => (
                <p key={idx} className="text-gray-700 mb-4">{para}</p>
              ))
            : <p className="text-gray-700 mb-4">{readingText}</p>
          }
        </div>
      )}
    </div>
  );
};

export default WritingTask1Intro;
